import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { LockIcon } from "assets/icons";
import { getIn, useFormik } from "formik";
import md5 from "md5";
import { changePassword, isSaving } from "stores/slices/user";
import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";

const UserUpdatePasswordForm = props => {
  const { onCancel } = props;
  const { t } = useTranslation();
  const loading = useSelector(isSaving);
  const initialValues = {
    oldPassword: "",
    password: "",
    confirmPassword: "",
  };

  const dispatch = useDispatch();

  const inputItems = [
    {
      type: "password",
      key: "oldPassword",
      label: t("label.currentPassword"),
      placeholder: "label.currentPassword",
      icon: <LockIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
    },
    {
      type: "password",
      key: "password",
      label: t("label.newPassword"),
      placeholder: "label.newPassword",
      icon: <LockIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
    },
    {
      type: "password",
      key: "confirmPassword",
      label: t("label.confirmPassword"),
      placeholder: "label.placConfirmPassword",
      icon: <LockIcon />,
      span: 24,
      colon: true,
      style: {
        marginBottom: 16,
      },
    },
  ];

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("validate.required"),
    password: YupValidations.password,
    confirmPassword: YupValidations.confirmPassword,
  });
  const onSubmitForm = data => {
    const request = {
      oldPassword: md5(data.oldPassword),
      newPassword: md5(data.password),
      confirmPassword: md5(data.confirmPassword),
    };
    dispatch(changePassword(request));
  };
  const handleForm = useFormik({
    initialValues: {
      oldPassword: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitForm,
  });

  const { values, setFieldValue, handleSubmit, setValues } = handleForm;

  return (
    <div style={{ height: "100%" }}>
      <FormInput
        items={inputItems.map(item => {
          item.label = t(item.label);
          if (item.key) {
            item.value = getIn(values, item.key);
          }
          return { ...item };
        })}
        form={handleForm}
        onChange={setFieldValue}
        layout={"vertical"}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginTop: "10px",
        }}
      >
        <AppButton
          label={t("label.cancel")}
          color={"grey"}
          loading={loading}
          type="button"
          onClick={() => {
            onCancel();
            setValues(initialValues);
            handleForm.resetForm();
          }}
          size={"minimum"}
          className={"cancelButton"}
        />
        <AppButton
          label={t("label.save")}
          color={"blue"}
          loading={loading}
          type="submit"
          onClick={handleSubmit}
          size={"minimum"}
        />
      </div>
    </div>
  );
};

export default UserUpdatePasswordForm;
